import Cookies from 'js-cookie'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray } from '@/common/js/utils'

export function getCustomStorage(name) {
  const account = Cookies.get('ch_op_id')
  const storage = getLocal(name)
  if (storage && isArray(storage[account])) return storage[account]
  else return null
}
export function setCustomStorage(name, list) {
  const account = Cookies.get('ch_op_id')
  let storage = getLocal(name)
  if (!storage) storage = {}
  storage[account] = list
  setLocal(name, storage)
}
